import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import './Patterns.css';

export type AlertTone = 'danger' | 'warn' | 'info';

export interface AlertCardProps {
  title: string;
  count: number;
  tone: AlertTone;
  /** Optional "View all →" link href. If omitted, no link renders. */
  viewAllHref?: string;
  /** Optional onClick for the "View all" link (use either href or onClick, not both). */
  onViewAll?: () => void;
  children: ReactNode;
}

const AlertCard: React.FC<AlertCardProps> = ({ title, count, tone, viewAllHref, onViewAll, children }) => {
  const { t } = useTranslation();
  return (
    <div className={`pat-alert-card pat-alert-card--${tone}`} data-testid="alert-card">
      <div className="pat-alert-card__header">
        <h3 className="pat-alert-card__title">{title}</h3>
        {count > 0 && (
          <span className="pat-alert-card__count" data-testid="alert-card-count">{count}</span>
        )}
        {(viewAllHref || onViewAll) && (
          viewAllHref ? (
            <a className="pat-alert-card__view-all" href={viewAllHref} onClick={onViewAll}>
              {t('patterns.alertCard.viewAll')}
            </a>
          ) : (
            <button
              type="button"
              className="pat-alert-card__view-all pat-alert-card__view-all--button"
              onClick={onViewAll}
            >
              {t('patterns.alertCard.viewAll')}
            </button>
          )
        )}
      </div>
      <div className="pat-alert-card__body">{children}</div>
    </div>
  );
};

export default AlertCard;
